import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaGithub, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import TesseractLogo from './TesseractLogo';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-grid">
                    <div className="footer-about">
                        <Link to="/" className="footer-brand">
                            <TesseractLogo size={26} color="#00b4d8" className="brand-icon" />
                            <span>Tesser<span className="brand-highlight">active</span></span>
                        </Link>
                        <p>We build custom AI agents and intelligent tools that automate business operations. Led by Ivan Smith, we turn AI into your competitive advantage.</p>
                        <div className="footer-social">
                            <a href="https://www.linkedin.com/in/ivan-smith-54806547/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
                            <a href="https://github.com/ivansmith7795/" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><FaGithub /></a>
                        </div>
                    </div>

                    <div className="footer-links-col">
                        <h4>Services</h4>
                        <ul>
                            <li><Link to="/services">AI Agent Development</Link></li>
                            <li><Link to="/services">Custom AI Tools</Link></li>
                            <li><Link to="/services">Agentic Workflows</Link></li>
                            <li><Link to="/services">LLMs & Generative AI</Link></li>
                        </ul>
                    </div>

                    <div className="footer-links-col">
                        <h4>Company</h4>
                        <ul>
                            <li><Link to="/about">About Ivan</Link></li>
                            <li><Link to="/case-studies">Case Studies</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="footer-contact">
                        <h4>Get in Touch</h4>
                        <div className="contact-item">
                            <FaEnvelope />
                            <span>ivan.smith@datavisionlabs.ai</span>
                        </div>
                        <div className="contact-item">
                            <FaPhone />
                            <span>+1.403.966.9715</span>
                        </div>
                        <div className="contact-item">
                            <FaMapMarkerAlt />
                            <span>Calgary, Alberta, Canada</span>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} Tesseractive Inc. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
